module.exports = __webpack_public_path__ + "static/media/flags_debit.fd627452.png";